import { render, staticRenderFns } from "./rotator.vue?vue&type=template&id=796e4e7c&scoped=true&lang=pug"
import script from "./rotator.vue?vue&type=script&lang=coffee"
export * from "./rotator.vue?vue&type=script&lang=coffee"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796e4e7c",
  null
  
)

export default component.exports